import { APIConfig } from "./API";

export const productionApiConfig: APIConfig = {
    apiBaseUrl: "https://api.medflyt.com"
};

export const stagingApiConfig: APIConfig = {
    apiBaseUrl: "https://medflyt-api-staging.herokuapp.com"
};

export const localApiConfig: APIConfig = {
    apiBaseUrl: "http://localhost:3000"
};

const API_CONFIG_KEY: string = "medflyt_app_api_config";

const API_BOOKMARKS_KEY: string = "medflyt_app_api_bookmarks";

export function getAPIBookmarks(): string[] {
    const data = window.localStorage.getItem(API_BOOKMARKS_KEY);
    if (data !== null) {
        // TODO validation + versioning
        return JSON.parse(data);
    } else {
        return [];
    }
}

export function addAPIBookmark(api: string): void {
    const prev = getAPIBookmarks();
    prev.push(api);
    window.localStorage.setItem(API_BOOKMARKS_KEY, JSON.stringify(prev));
}

export function clearAPIBookmarks(): void {
    window.localStorage.removeItem(API_BOOKMARKS_KEY);
}

export function loadAPIConfig(): APIConfig {
    const data = window.localStorage.getItem(API_CONFIG_KEY);
    if (data === null) {
        return productionApiConfig;
    }

    // TODO validate + versioning
    return JSON.parse(data);
}

export function saveAPIConfig(apiConfig: APIConfig): void {
    window.localStorage.setItem(API_CONFIG_KEY, JSON.stringify(apiConfig));
}



// WEBPACK FOOTER //
// ./src/LocalStore.ts